import { render } from "./CalendarDays.vue?vue&type=template&id=0b007f8a&scoped=true"
import script from "./CalendarDays.vue?vue&type=script&lang=js"
export * from "./CalendarDays.vue?vue&type=script&lang=js"

import "./CalendarDays.vue?vue&type=style&index=0&id=0b007f8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b007f8a"]])

export default __exports__